import type { Material, OrderLine, ProductCost } from '../types'

/**
 * Ürün maliyeti (18 Eki 2026). Kiloyla satılan üründe 1 kg'ın, diğerlerinde
 * 1 adedin maliyeti, kuruş. Girilmemişse null.
 *
 * Hammaddeden hesapta silinmiş ya da bulunamayan hammadde sayılmıyor; ekranda
 * ayrıca uyarılıyor.
 */
export function unitCostKurus(cost: ProductCost | undefined, materials: Map<string, Material>): number | null {
  if (!cost) return null
  if (cost.mode === 'direct') return cost.costKurus
  if (cost.recipe.length === 0) return null
  let sum = 0
  for (const line of cost.recipe) {
    const m = materials.get(line.materialId)
    if (m) sum += m.priceKurus * line.qty
  }
  return Math.round(sum)
}

/** Bir reçete satırının tutarı, kuruş; hammadde yoksa null. */
export function lineCostKurus(qty: number, material: Material | undefined): number | null {
  return material ? Math.round(material.priceKurus * qty) : null
}

/**
 * Kar ve kar oranı (satış fiyatına göre, yüzde). Satış fiyatı 0 ise oran
 * null.
 */
export function margin(priceKurus: number, costKurus: number): { profitKurus: number; pct: number | null } {
  const profitKurus = priceKurus - costKurus
  return { profitKurus, pct: priceKurus > 0 ? (profitKurus / priceKurus) * 100 : null }
}

/** Miktar kutusu: rakam ve bir virgül, virgülden sonra en çok 3 hane (0,180 kg). */
export function qtyInput(text: string): string {
  const [whole, ...rest] = text.replace(/\./g, ',').replace(/[^\d,]/g, '').split(',')
  return rest.length ? `${whole},${rest.join('').slice(0, 3)}` : whole
}

/** "0,18" → 0.18; boş ya da bozuksa null. */
export function parseQty(s: string): number | null {
  const t = s.trim().replace(',', '.')
  if (t === '') return null
  const n = Number(t)
  return Number.isFinite(n) && n >= 0 ? n : null
}

/** 0.18 → "0,18" (input için). */
export const qtyToInput = (n: number) => String(Math.round(n * 1000) / 1000).replace('.', ',')

export const UNIT_LABEL: Record<Material['unit'], string> = { kg: 'kg', adet: 'adet', lt: 'lt' }

/**
 * Satırın maliyete giren miktarı: tartılı satırda tartılan net kg, diğerlerinde
 * adet. Maliyet de buna göre: 1 kg ya da 1 adet maliyeti ile çarpılır.
 */
export function soldUnits(line: Pick<OrderLine, 'qty' | 'weigh'>): number {
  const plates = line.weigh?.plates
  if (plates && plates.length) return plates.reduce((s, p) => s + (p.netGr || 0), 0) / 1000
  return line.qty
}
